import type { FaireProductEntity } from "../../entity_types/product";

export const p_fyh4x9vn2x: FaireProductEntity = {
  token: "p_fyh4x9vn2x",
  type: "product",
  name: "SPECIAL SALE! Jewelry Mystery Box Deal - 20 Pieces",
  brandToken: "b_3u7f7kz1",
  brandName: "Golden NYC Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/15a39ceb38f23f37b19ec93b0b1c894e5500f74f95ab0f208040f6a5d4945780.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.93,
  description:
    "Try out our fun mystery box picks. You're in for a great dazzling jewelry surprise!\n\nTotal value is over $99!\n\nChoose your ring size and head to checkout!\n\nBRAND: GENERIC\nMODEL: MYSTERY!\n\nCONDITION: NEW\nPOSSIBLE OPTIONS: STERLING SILVER, SILVER PLATED, SWAROVSKI, GOLD PLATED, & GOLD FILLED\nWARRANTY: ALL SALES FINAL\nPACKAGING: RETAIL",
  tags: [],
  msrpDollars: 62.34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:44.013Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
